"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STATUSES_ARRAY = void 0;
exports.STATUSES_ARRAY = [
    ["Aktywny", "active"],
    ["Oczekujący", "pending"],
    ["Dezaktywowany", "deactivate"],
];
//# sourceMappingURL=Profile.js.map